import React from 'react';

import svgInfo from './svgInfo';

type Props = {
  readonly className?: string;
  readonly translateImageUrl: string;
  readonly backgroundColor?: string;
  readonly appliance: string;
  readonly quantity: string | number;
  readonly units: string;
};

export default function EnergySVG({
  className,
  translateImageUrl,
  backgroundColor,
  appliance,
  quantity,
  units,
}: Props): React.ReactElement {
  let quantitySize = '';

  if (String(quantity).length < 3) {
    quantitySize = 'smallQuantity';
  } else if (String(quantity).length === 3) {
    quantitySize = 'mediumQuantity';
  } else {
    quantitySize = 'largeQuantity';
  }

  return (
    <svg
      className={className}
      viewBox="0 0 320 180"
      style={{ background: backgroundColor }}
      role="img"
    >
      <image
        xlinkHref={`${translateImageUrl}energy/appliances/${appliance}.svg`}
        width="116"
        height="116"
        preserveAspectRatio="none"
        transform="translate(32 32)"
      />
      <circle
        cx="230"
        cy="90"
        r="58"
        stroke="rgba(255,255,255,0.3)"
        strokeWidth="5"
        fill="none"
        strokeDasharray="5"
      />
      <text
        x="231"
        y={svgInfo[quantitySize].quantityYPosition}
        textAnchor="middle"
        style={{
          fontFamily: 'Montserrat',
          fontSize: svgInfo[quantitySize].fontSize,
          fontWeight: 'bold',
          fill: '#fff',
        }}
      >
        {quantity}
      </text>
      <text
        x="231"
        y={svgInfo[quantitySize].unitYPosition}
        textAnchor="middle"
        style={{
          fontFamily: 'Montserrat',
          fontSize: 18,
          fill: '#fff',
        }}
      >
        {units}
      </text>
    </svg>
  );
}
